import promoPriceCalculator from '@sharedModules/promo-price-calculator';
import { isNil, set } from 'lodash';

const { roundProductPrices } = promoPriceCalculator;

const buildNewPriceProductUpdates = ({ products, params, value }) =>
    products.flatMap(product => {
        const productParams = {
            ...params,
            productKey: product.productKey,
            data: product,
        };
        const { nonPromoPrices } = product;
        let avgPriceExcTax = null;
        if (!isNil(nonPromoPrices?.avgPrice) && !isNil(nonPromoPrices.avgPriceExcTax)) {
            if (nonPromoPrices.avgPrice === 0) {
                avgPriceExcTax = 0;
            } else {
                avgPriceExcTax = (nonPromoPrices.avgPriceExcTax / nonPromoPrices.avgPrice) * value;
            }
        }
        const avgPriceExcTaxRounded = roundProductPrices({
            productPrices: { avgPriceExcTax },
        }).avgPriceExcTax;

        return [
            {
                ...productParams,
                priceId: 'avgPriceExcTax',
                value: avgPriceExcTaxRounded,
            },
            {
                ...productParams,
                priceIds: ['avgPrice', 'minPrice', 'maxPrice'],
            },
        ];
    });

const updateGridProductPrices = ({ products, tierIndex, value, getRowNode }) => {
    const rowNodes = [];

    products.forEach(product => {
        const rowNode = getRowNode(String(product.productKey));
        if (!rowNode) return;

        set(rowNode.data, `promoPrices.${tierIndex}.avgPrice`, value);
        set(rowNode.data, `promoPrices.${tierIndex}.minPrice`, value);
        set(rowNode.data, `promoPrices.${tierIndex}.maxPrice`, value);
        rowNodes.push(rowNode);
    });

    return rowNodes;
};

export { buildNewPriceProductUpdates, updateGridProductPrices };
